import * as Sentry from "@sentry/angular";

import { registerLocaleData } from "@angular/common";
import localeIt from "@angular/common/locales/es-CL";
import localeItExtra from "@angular/common/locales/extra/es-CL";
import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

Sentry.init({
  dsn: "https://229f57a85afb1c4fa6289d936b31c3bb@o4510619740930048.ingest.us.sentry.io/4510665754083328",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  enableLogs: true,
  sendDefaultPii: true,
  tracePropagationTargets: [
    /^https:\/\/iot\.rioingenieria\.cl/,
    /^https:\/\/iot-sta\.rioingenieria\.cl/,
  ],
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
registerLocaleData(localeIt, "es-CL", localeItExtra);
